import React from 'react';
import TabbedPage from '../../../Elements/TabbedPage';
import AssignmentAdmin from './AssignmentAdmin';
import OpenAssignmentAdmin from './OpenAssignments/OpenAssignmentAdmin';
import OrphanedAssignmentsClientGroupedAdmin from './OrphanedAssignment/OrphanedAssignmentsClientGroupedAdmin';
import AssignmentListOrphanClientAdmin from './OrphanedAssignment/AssignmentListOrphanClientAdmin';
import AssignmentListOrphanProjectAdmin from './OrphanedAssignment/AssignmentListOrphanProjectAdmin';
import AssignmentListOrphanCompletedDateAdmin from './OrphanedAssignment/AssignmentListOrphanCompletedDateAdmin';
import OrphanedAssignmentsProjectGroupedByOfficeAdmin from './OrphanedAssignment/OrphanedAssignmentsProjectGroupedByOfficeAdmin';
import MyOfficeAssignmentSummaryAdmin from './MyOfficeAssignment/MyOfficeAssignmentSummaryAdmin';

export default class AssignmentParentAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {};
  }

  tabs = [
    { label: 'Assignments', id: 'assignment', icon: 'fa-solid fa-clipboard-list', component: <AssignmentAdmin /> },
    {
      label: 'Open Assignments',
      id: 'openassignment',
      icon: 'fa-solid fa-clipboard',
      component: <OpenAssignmentAdmin />,
    },
    {
      label: 'Orphaned - Missing Clients: Grouped',
      id: 'orphanedassignmentclientgrouped',
      icon: 'fa-solid fa-clipboard',
      component: <OrphanedAssignmentsClientGroupedAdmin />,
    },
    {
      label: 'Orphaned - Missing Clients: Full List',
      id: 'orphanedassignmentclient',
      icon: 'fa-solid fa-clipboard',
      component: <AssignmentListOrphanClientAdmin />,
    },
    {
      label: 'Orphaned - Missing Projects: Grouped',
      id: 'orphanedassignmentprojectgrouped',
      icon: 'fa-solid fa-clipboard',
      component: <OrphanedAssignmentsProjectGroupedByOfficeAdmin />,
    },
    {
      label: 'Orphaned - Missing Projects: Full List',
      id: 'orphanedassignmentproject',
      icon: 'fa-solid fa-clipboard',
      component: <AssignmentListOrphanProjectAdmin />,
    },
    {
      label: 'Orphaned - Missing Completed Date',
      id: 'orphanedassignmentcompleteddate',
      icon: 'fa-solid fa-clipboard',
      component: <AssignmentListOrphanCompletedDateAdmin />,
    },
    {
      label: 'My Office Uninvoiced Assignments',
      id: 'myofficeuninvoicedassignment',
      icon: 'fa-solid fa-clipboard',
      component: <MyOfficeAssignmentSummaryAdmin />,
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.window}
        <div className='bg-white p-1'>
          <div className='TabbedPage'>
            <TabbedPage tabs={this.tabs} />
          </div>
        </div>
      </div>
    );
  }
}
